<!-- Call to action block
     Requires:
     - title and text
     Optionally Contains:
     - contact name and email
     - button to page/document/external url with text
-->

<template>
  <mdb-container>
    <mdb-row class="pt-5">
      <mdb-col>
        <mdb-card>
          <div class="secondary-card">
            <mdb-card-body>
              <mdb-card-title style="color: white !important;"><strong>{{block.value.title_and_text.title}}</strong></mdb-card-title>
              <h5 class="text-white">{{block.value.title_and_text.text}}</h5>

              <!--Display contact info properly with or without name.-->

              <h5 class="text-white" v-if="block.value.contact_name && block.value.contact_email">
                Want to learn more? Contact {{block.value.contact_name}} at {{block.value.contact_email}}
              </h5>
              <h5 class="text-white" v-if="!block.value.contact_name && block.value.contact_email">
                Want to learn more? Contact us at {{block.value.contact_email}}
              </h5>

              <!--Display the extra information button (dependent on button type).-->

              <router-link v-if="block.value.button_page" :to="`/${block.value.button_page.link_page}/${block.value.button_page.slug}`">
                <mdb-btn color="primary">{{block.value.button_text}}</mdb-btn>
              </router-link>
              <a v-else-if="block.value.button_url" :href="block.value.button_url" target="_blank"><mdb-btn color="primary">{{block.value.button_text}}</mdb-btn></a>
              <router-link v-else-if="block.value.button_document" :to="`/${block.value.button_document.link_page}/${block.value.button_document.slug}`">
                <mdb-btn color="primary">{{block.value.button_text}}</mdb-btn>
              </router-link>
            </mdb-card-body>
          </div>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbRow, 
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbBtn,
  mdbCardTitle
} from "mdbvue"
export default {
  name: "call_to_action",
  components: {
    mdbContainer, 
    mdbRow, 
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbBtn,
    mdbCardTitle
  },
  props: {
    block: Object
  },
}
</script>

<style scoped>
a {
   color: white !important; 
}
</style>